import React, { useState, useEffect } from "react";
import { useDispatch, useSelector } from "react-redux";
import { WalletItemDriverLicence } from "../../../store/common";
import * as httpClient from "../../../util/httpClient";
import { Notification } from "../../common/Notification";
import { useForm } from "react-hook-form";
import { countryList } from "../../../util/CommonLists";
import { getFlowByName } from "../../../config/FlowName";
import * as NextStepFlowAction from "../../../store/nextStepFlowService/actions";
import { ApplicationState } from "../../../store";
import i18nService from "../../../util/Internationalization/i18n/i18n";
import { PATTERNS } from "../../../util/patterns";
import { useTranslation } from "react-i18next";

const DriverLicenseDialog: React.FunctionComponent<{ requestDataCallback(): void; walletItem: WalletItemDriverLicence; isNew: boolean; closeDialog(): void }> = (
    props
) => {
    const { t: tLang, i18n: i18nLang } = useTranslation();
    const [isLoading, setisLoading] = useState(false);

    const dispatch = useDispatch();
    const [driverLicense, setDriverLicense] = useState(props.walletItem);
    const [errorMsg, seterrorMsg] = useState("");
    const lostWalletFlow = useSelector((state: ApplicationState) => getFlowByName(state, "LOST-WALLET-ASSISTANCE"));
    const completeGetStartedItem = (flowID: any, flowName: string) => dispatch(NextStepFlowAction.actionCreators.completeGetStartedItem(flowID, flowName));
    const [hasError, setHasError] = useState(false);

    const [dateOfBirth, setDateOfBirth] = useState({
        birthMonth: props.walletItem.dateOfBirth ? props.walletItem.dateOfBirth.trim().split("/")[0] : "",
        birthDay: props.walletItem.dateOfBirth ? props.walletItem.dateOfBirth.trim().split("/")[1] : "",
        birthYear: props.walletItem.dateOfBirth ? props.walletItem.dateOfBirth.trim().split("/")[2] : "",
    });

    const [issueDate, setIssueDate] = useState({
        issueMonth: props.walletItem.issueDate ? props.walletItem.issueDate.trim().split("/")[0] : "",
        issueDay: props.walletItem.issueDate ? props.walletItem.issueDate.trim().split("/")[1] : "",
        issueYear: props.walletItem.issueDate ? props.walletItem.issueDate.trim().split("/")[2] : "",
    });

    const [expirationDate, setExpirationDate] = useState({
        expirationMonth: props.walletItem.expirationDate ? props.walletItem.expirationDate.trim().split("/")[0] : "",
        expirationDay: props.walletItem.expirationDate ? props.walletItem.expirationDate.trim().split("/")[1] : "",
        expirationYear: props.walletItem.expirationDate ? props.walletItem.expirationDate.trim().split("/")[2] : "",
    });

    const months = [
        { name: "Jan", value: "01" },
        { name: "Feb", value: "02" },
        { name: "Mar", value: "03" },
        { name: "Apr", value: "04" },
        { name: "May", value: "05" },
        { name: "Jun", value: "06" },
        { name: "Jul", value: "07" },
        { name: "Aug", value: "08" },
        { name: "Sep", value: "09" },
        { name: "Oct", value: "10" },
        { name: "Nov", value: "11" },
        { name: "Dec", value: "12" },
    ];

    /**Validation with react-hook-form ***/
    const { register, errors, formState, handleSubmit } = useForm({
        mode: "onBlur",
        reValidateMode: "onChange",
    });

    const { isValid, isSubmitting } = formState;

    useEffect(() => {
        if (dateOfBirth) {
            if (
                dateOfBirth.birthDay &&
                dateOfBirth.birthDay.length > 0 &&
                dateOfBirth.birthMonth &&
                dateOfBirth.birthMonth.length > 0 &&
                dateOfBirth.birthYear &&
                dateOfBirth.birthYear.length > 0
            ) {
                setDriverLicense({ ...driverLicense, dateOfBirth: dateOfBirth.birthMonth + "/" + dateOfBirth.birthDay + "/" + dateOfBirth.birthYear });
            } else {
                setDriverLicense({
                    ...driverLicense,
                    dateOfBirth: undefined,
                });
            }
        }
    }, [dateOfBirth]);

    useEffect(() => {
        if (issueDate) {
            if (
                issueDate.issueDay &&
                issueDate.issueDay.length > 0 &&
                issueDate.issueMonth &&
                issueDate.issueMonth.length > 0 &&
                issueDate.issueYear &&
                issueDate.issueYear.length > 0
            ) {
                setDriverLicense({ ...driverLicense, issueDate: issueDate.issueMonth + "/" + issueDate.issueDay + "/" + issueDate.issueYear });
            } else {
                setDriverLicense({
                    ...driverLicense,
                    issueDate: undefined,
                });
            }
        }
    }, [issueDate]);

    useEffect(() => {
        if (expirationDate) {
            if (
                expirationDate.expirationDay &&
                expirationDate.expirationDay.length > 0 &&
                expirationDate.expirationMonth &&
                expirationDate.expirationMonth.length > 0 &&
                expirationDate.expirationYear &&
                expirationDate.expirationYear.length > 0
            ) {
                setDriverLicense({
                    ...driverLicense,
                    expirationDate: expirationDate.expirationMonth + "/" + expirationDate.expirationDay + "/" + expirationDate.expirationYear,
                });
            } else {
                setDriverLicense({
                    ...driverLicense,
                    expirationDate: undefined,
                });
            }
        }
    }, [expirationDate]);

    const closeDialog = () => {
        document.body.classList.remove("no_scroll");
        props.closeDialog();
    };

    const refreswalletItem = () => {
        closeDialog();
        props.requestDataCallback();
    };

    function onChangeHandler(event: any) {
        setHasError(false);
        const elName = event.currentTarget.name;
        setDriverLicense({ ...driverLicense, [elName as string]: event.currentTarget.value });
    }

    function onDobChangeHandler(event: any) {
        setHasError(false);
        const elName = event.currentTarget.name;
        setDateOfBirth({ ...dateOfBirth, [elName as string]: event.currentTarget.value });
    }

    function onIssueDateChangeHandler(event: any) {
        setHasError(false);
        const elName = event.currentTarget.name;
        setIssueDate({ ...issueDate, [elName as string]: event.currentTarget.value });
    }

    function onExpirationDateChangeHandler(event: any) {
        setHasError(false);
        const elName = event.currentTarget.name;
        setExpirationDate({ ...expirationDate, [elName as string]: event.currentTarget.value });
    }

    const saveItem = () => {
        const requestBody = {
            "lost-wallet": {
                "lost-wallet-driver": driverLicense,
            },
        };
        setisLoading(true);
        httpClient
            .sendRequest("POST", "api/lostWallet/" + (props.isNew ? "addNewwalletItem" : "updatewalletItem"), requestBody)
            .then((data) => {
                setisLoading(false);
                if (data.isSuccess) {
                    if (lostWalletFlow && lostWalletFlow.flowStepStatus !== "COMPLETED") {
                        completeGetStartedItem(lostWalletFlow.flowStepId, lostWalletFlow.flowName ? lostWalletFlow.flowName : " ");
                    }
                    Notification({
                        type: "success",
                        title: props.isNew
                            ? tLang("identityVault.secureStorage.lostWallterWidget.drivingLicensePopup.addToastTitle")
                            : tLang("identityVault.secureStorage.lostWallterWidget.drivingLicensePopup.updateToastTitle"),
                        message: props.isNew
                            ? tLang("identityVault.secureStorage.lostWallterWidget.drivingLicensePopup.addToastMessage")
                            : tLang("identityVault.secureStorage.lostWallterWidget.drivingLicensePopup.updateToastMessage"),
                    });
                    refreswalletItem();
                } else if (data.hasError && data.errors.length > 0) {
                    seterrorMsg(data.errors.join(", "));
                    setHasError(true);
                } else {
                    seterrorMsg(tLang("identityVault.secureStorage.lostWallterWidget.drivingLicensePopup.unknownError"));
                    setHasError(true);
                }
            })
            .catch(function (error) {
                setisLoading(false);
                Notification({
                    type: "error",
                    title: tLang("identityVault.secureStorage.lostWallterWidget.drivingLicensePopup.errorToastTitle"),
                    message: tLang("identityVault.secureStorage.lostWallterWidget.drivingLicensePopup.errorToastMesage"),
                    duration: 0,
                });
                closeDialog();
            });
    };

    const dateFields = [
        <div className="col-xs-4 col-no-gutter">
            <div className="form-row row">
                <div className="form-label sr-only col-xs-12 col-no-gutter">
                    <label htmlFor="label-dob-day">Date of Birth Day</label>
                </div>
                <div className="form-input col-xs-12 col-no-gutter padding-right-xs">
                    <select
                        ref={register}
                        name="birthDay"
                        role="listbox"
                        className="inputbox"
                        id="label-dob-day"
                        defaultValue={dateOfBirth.birthDay}
                        onChange={onDobChangeHandler}
                    >
                        <option value="">{tLang("identityVault.secureStorage.lostWallterWidget.drivingLicensePopup.dropdownHeaders.dateDay")}</option>
                        {Array(31)
                            .fill(null)
                            .map((value, index) => {
                                return (
                                    <option key={index + 1} value={index < 9 ? "0" + (index + 1) : index + 1}>
                                        {index < 9 ? "0" + (index + 1) : index + 1}
                                    </option>
                                );
                            })}
                    </select>
                </div>
            </div>
        </div>,
        <div className="col-xs-4 col-no-gutter">
            <div className="form-row row">
                <div className="form-label sr-only col-xs-12 col-no-gutter">
                    <label htmlFor="label-dob-month1">Date of Birth Month</label>
                </div>
                <div className="form-input col-xs-12 col-no-gutter padding-right-xs">
                    <select
                        ref={register}
                        name="birthMonth"
                        role="listbox"
                        className="inputbox"
                        id="label-dob-month"
                        defaultValue={dateOfBirth.birthMonth}
                        onChange={onDobChangeHandler}
                    >
                        <option value="">{tLang("identityVault.secureStorage.lostWallterWidget.drivingLicensePopup.dropdownHeaders.dateMonth")}</option>
                        {months.map((month) => {
                            return (
                                <option key={month.value} value={month.value}>
                                    {month.name}
                                </option>
                            );
                        })}
                    </select>
                </div>
            </div>
        </div>,
        <div className="col-xs-4 col-no-gutter">
            <div className="form-row row">
                <div className="form-label sr-only col-xs-12 col-no-gutter ">
                    <label htmlFor="label-dob-year">Date of Birth Year</label>
                </div>
                <div className="form-input col-xs-12 col-no-gutter padding-right-xs">
                    <select
                        ref={register}
                        name="birthYear"
                        role="listbox"
                        className="inputbox"
                        id="label-dob-year"
                        defaultValue={dateOfBirth.birthYear}
                        onChange={onDobChangeHandler}
                    >
                        <option value="">{tLang("identityVault.secureStorage.lostWallterWidget.drivingLicensePopup.dropdownHeaders.dateYear")}</option>
                        {Array(115)
                            .fill(null)
                            .map((value, index) => {
                                const optionValue = new Date().getFullYear() - index;
                                return (
                                    <option key={optionValue} value={optionValue}>
                                        {optionValue}
                                    </option>
                                );
                            })}
                    </select>
                </div>
            </div>
        </div>,
    ];

    const issueDateFields = [
        <div className="col-xs-4 col-no-gutter">
            <div className="form-row row">
                <div className="form-label sr-only col-xs-12 col-no-gutter">
                    <label htmlFor="label-issue-day">Issue Day</label>
                </div>
                <div className="form-input col-xs-12 col-no-gutter padding-right-xs">
                    <select
                        ref={register}
                        name="issueDay"
                        role="listbox"
                        className="inputbox"
                        id="label-issue-day"
                        defaultValue={issueDate.issueDay}
                        onChange={onIssueDateChangeHandler}
                    >
                        <option value="">{tLang("identityVault.secureStorage.lostWallterWidget.drivingLicensePopup.dropdownHeaders.dateDay")}</option>
                        {Array(31)
                            .fill(null)
                            .map((value, index) => {
                                return (
                                    <option key={index + 1} value={index < 9 ? "0" + (index + 1) : index + 1}>
                                        {index < 9 ? "0" + (index + 1) : index + 1}
                                    </option>
                                );
                            })}
                    </select>
                </div>
            </div>
        </div>,
        <div className="col-xs-4 col-no-gutter">
            <div className="form-row row">
                <div className="form-label sr-only col-xs-12 col-no-gutter">
                    <label htmlFor="label-issue-month1">Issue Month</label>
                </div>
                <div className="form-input col-xs-12 col-no-gutter padding-right-xs">
                    <select
                        ref={register}
                        name="issueMonth"
                        role="listbox"
                        className="inputbox"
                        id="label-issue-month"
                        defaultValue={issueDate.issueMonth}
                        onChange={onIssueDateChangeHandler}
                    >
                        <option value="">{tLang("identityVault.secureStorage.lostWallterWidget.drivingLicensePopup.dropdownHeaders.dateMonth")}</option>
                        {months.map((month) => {
                            return (
                                <option key={month.value} value={month.value}>
                                    {month.name}
                                </option>
                            );
                        })}
                    </select>
                </div>
            </div>
        </div>,
        <div className="col-xs-4 col-no-gutter">
            <div className="form-row row">
                <div className="form-label sr-only col-xs-12 col-no-gutter">
                    <label htmlFor="label-issue-year">Issue Year</label>
                </div>
                <div className="form-input col-xs-12 col-no-gutter padding-right-xs">
                    <select
                        ref={register}
                        name="issueYear"
                        role="listbox"
                        className="inputbox"
                        id="label-issue-year"
                        defaultValue={issueDate.issueYear}
                        onChange={onIssueDateChangeHandler}
                    >
                        <option value="">{tLang("identityVault.secureStorage.lostWallterWidget.drivingLicensePopup.dropdownHeaders.dateYear")}</option>
                        {Array(100)
                            .fill(null)
                            .map((value, index) => {
                                const optionValue = new Date().getFullYear() - index;
                                return (
                                    <option key={optionValue} value={optionValue}>
                                        {optionValue}
                                    </option>
                                );
                            })}
                    </select>
                </div>
            </div>
        </div>,
    ];

    const expiryDateFields = [
        <div className="col-xs-4 col-no-gutter">
            <div className="form-row row">
                <div className="form-label sr-only col-xs-12 col-no-gutter">
                    <label htmlFor="label-expiration-day">Expiration Day</label>
                </div>
                <div className="form-input col-xs-12 col-no-gutter padding-right-xs">
                    <select
                        ref={register}
                        name="expirationDay"
                        role="listbox"
                        className="inputbox"
                        id="label-expiration-day"
                        defaultValue={expirationDate.expirationDay}
                        onChange={onExpirationDateChangeHandler}
                    >
                        <option value="">{tLang("identityVault.secureStorage.lostWallterWidget.drivingLicensePopup.dropdownHeaders.dateDay")}</option>
                        {Array(31)
                            .fill(null)
                            .map((value, index) => {
                                return (
                                    <option key={index + 1} value={index < 9 ? "0" + (index + 1) : index + 1}>
                                        {index < 9 ? "0" + (index + 1) : index + 1}
                                    </option>
                                );
                            })}
                    </select>
                </div>
            </div>
        </div>,
        <div className="col-xs-4 col-no-gutter">
            <div className="form-row row">
                <div className="form-label sr-only col-xs-12 col-no-gutter">
                    <label htmlFor="label-expiration-month1">Expiration Month</label>
                </div>
                <div className="form-input col-xs-12 col-no-gutter padding-right-xs">
                    <select
                        ref={register}
                        name="expirationMonth"
                        role="listbox"
                        className="inputbox"
                        id="label-expiration-month"
                        defaultValue={expirationDate.expirationMonth}
                        onChange={onExpirationDateChangeHandler}
                    >
                        <option value="">{tLang("identityVault.secureStorage.lostWallterWidget.drivingLicensePopup.dropdownHeaders.dateMonth")}</option>
                        {months.map((month) => {
                            return (
                                <option key={month.value} value={month.value}>
                                    {month.name}
                                </option>
                            );
                        })}
                    </select>
                </div>
            </div>
        </div>,
        <div className="col-xs-4 col-no-gutter">
            <div className="form-row row">
                <div className="form-label sr-only col-xs-12 col-no-gutter">
                    <label htmlFor="label-expiration-year">Expiration Year</label>
                </div>
                <div className="form-input col-xs-12 col-no-gutter padding-right-xs">
                    <select
                        ref={register}
                        name="expirationYear"
                        role="listbox"
                        className="inputbox"
                        id="label-expiration-year"
                        defaultValue={expirationDate.expirationYear}
                        onChange={onExpirationDateChangeHandler}
                    >
                        <option value="">{tLang("identityVault.secureStorage.lostWallterWidget.drivingLicensePopup.dropdownHeaders.dateYear")}</option>
                        {Array(10)
                            .fill(null)
                            .map((value, index) => {
                                const optionValue = new Date().getFullYear() + index;
                                return (
                                    <option key={optionValue} value={optionValue}>
                                        {optionValue}
                                    </option>
                                );
                            })}
                    </select>
                </div>
            </div>
        </div>,
    ];

    return (
        <React.Fragment>
            {!isLoading ? (
                <>
                    <div className="dialog-header">
                        <div className="dialog-icon">
                            <em className={props.isNew ? "las la-plus" : "las la-edit"}></em>
                        </div>
                        <h1>
                            {props.isNew
                                ? tLang("identityVault.secureStorage.lostWallterWidget.drivingLicensePopup.addLabel")
                                : tLang("identityVault.secureStorage.lostWallterWidget.drivingLicensePopup.editLabel")}{" "}
                            {tLang("identityVault.secureStorage.lostWallterWidget.drivingLicensePopup.title")}
                        </h1>
                    </div>
                    <form onSubmit={handleSubmit(saveItem)} id="driver-license-form-container">
                        <div className="dialog-body large-dialog-scroll">
                            <div className={errors["firstName"] ? "form-row row status-error" : "form-row row"}>
                                <div className="form-row inline row">
                                    <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                        <label htmlFor="edit-first-name">
                                            {tLang("identityVault.secureStorage.lostWallterWidget.drivingLicensePopup.label.fname")}{" "}
                                            <span className="required" title="Mandatory">
                                                *
                                            </span>
                                        </label>
                                    </div>
                                    <div role="alert" className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                        <input
                                            aria-required="true"
                                            type="text"
                                            className="inputbox"
                                            id="edit-first-name"
                                            aria-labelledby="edit-first-name"
                                            name="firstName"
                                            defaultValue={driverLicense.firstName}
                                            onChange={onChangeHandler}
                                            ref={register({
                                                required: true,
                                                pattern: PATTERNS.FIRSTNAME.pattern,
                                            })}
                                            maxLength={30}
                                        />
                                        {errors.firstName && errors.firstName.type === "pattern" && (
                                            <span className="form-error">
                                                {tLang("identityVault.secureStorage.lostWallterWidget.drivingLicensePopup.validationMessage.firstName.pattern")}
                                            </span>
                                        )}

                                        {errors.firstName && errors.firstName.type === "required" && (
                                            <span className="form-error">
                                                {tLang("identityVault.secureStorage.lostWallterWidget.drivingLicensePopup.validationMessage.firstName.required")}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className={errors["middleName"] ? "form-row row status-error" : "form-row row"}>
                                <div className="form-row inline row">
                                    <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                        <label htmlFor="edit-middle-initial">
                                            {tLang("identityVault.secureStorage.lostWallterWidget.drivingLicensePopup.label.mName")}
                                        </label>
                                    </div>
                                    <div role="alert" className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                        <input
                                            aria-required="true"
                                            type="text"
                                            className="inputbox"
                                            id="edit-middle-initial"
                                            aria-labelledby="edit-middle-initial"
                                            name="middleName"
                                            defaultValue={driverLicense.middleName}
                                            onChange={onChangeHandler}
                                            ref={register({
                                                pattern: PATTERNS.MIDDLE_INITIAL.pattern,
                                            })}
                                            maxLength={1}
                                        />
                                        {errors.middleName && errors.middleName.type === "pattern" && (
                                            <span className="form-error">
                                                {tLang("identityVault.secureStorage.lostWallterWidget.drivingLicensePopup.validationMessage.middleName.pattern")}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className={errors["lastName"] ? "form-row row status-error" : "form-row row"}>
                                <div className="form-row inline row">
                                    <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                        <label htmlFor="edit-last-name">
                                            {tLang("identityVault.secureStorage.lostWallterWidget.drivingLicensePopup.label.lName")}{" "}
                                            <span className="required" title="Mandatory">
                                                *
                                            </span>
                                        </label>
                                    </div>
                                    <div role="alert" className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                        <input
                                            aria-required="true"
                                            type="text"
                                            className="inputbox"
                                            id="edit-last-name"
                                            aria-labelledby="edit-last-name"
                                            name="lastName"
                                            defaultValue={driverLicense.lastName}
                                            onChange={onChangeHandler}
                                            ref={register({
                                                required: true,
                                                pattern: PATTERNS.LASTNAME.pattern,
                                            })}
                                            maxLength={30}
                                        />
                                        {errors.lastName && errors.lastName.type === "pattern" && (
                                            <span className="form-error">
                                                {tLang("identityVault.secureStorage.lostWallterWidget.drivingLicensePopup.validationMessage.lastName.pattern")}
                                            </span>
                                        )}

                                        {errors.lastName && errors.lastName.type === "required" && (
                                            <span className="form-error">
                                                {tLang("identityVault.secureStorage.lostWallterWidget.drivingLicensePopup.validationMessage.lastName.required")}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className="form-row inline row">
                                <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                    <label htmlFor="edit-suffix">{tLang("identityVault.secureStorage.lostWallterWidget.drivingLicensePopup.label.suffix")}</label>
                                </div>
                                <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                    <select
                                        className="inputbox"
                                        id="edit-suffix"
                                        aria-labelledby="edit-suffix"
                                        name="suffix"
                                        defaultValue={driverLicense.suffix}
                                        onChange={onChangeHandler}
                                    >
                                        <option value="">
                                            {tLang("identityVault.secureStorage.lostWallterWidget.drivingLicensePopup.dropdownHeaders.suffix")}
                                        </option>
                                        <option value="Sr">Sr</option>
                                        <option value="Jr">Jr</option>
                                        <option value="II">II</option>
                                        <option value="III">III</option>
                                        <option value="IV">IV</option>
                                    </select>
                                </div>
                            </div>

                            <div className="form-row inline row">
                                <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                    <label htmlFor="edit-sex">{tLang("identityVault.secureStorage.lostWallterWidget.drivingLicensePopup.label.sex")}</label>
                                </div>
                                <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                    <select
                                        className="inputbox"
                                        id="edit-sex"
                                        aria-labelledby="edit-sex"
                                        name="sex"
                                        defaultValue={driverLicense.sex}
                                        onChange={onChangeHandler}
                                    >
                                        <option value="">{tLang("identityVault.secureStorage.lostWallterWidget.drivingLicensePopup.dropdownHeaders.sex")}</option>
                                        <option value="Male">
                                            {tLang("identityVault.secureStorage.lostWallterWidget.drivingLicensePopup.label.sexDropDownList.male")}</option>
                                        <option value="Female">
                                            {tLang("identityVault.secureStorage.lostWallterWidget.drivingLicensePopup.label.sexDropDownList.female")}</option>
                                        <option value="Other">
                                            {tLang("identityVault.secureStorage.lostWallterWidget.drivingLicensePopup.label.sexDropDownList.other")}</option>
                                    </select>
                                </div>
                            </div>

                            <div className="form-row inline row">
                                <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                    <label htmlFor="edit-height">{tLang("identityVault.secureStorage.lostWallterWidget.drivingLicensePopup.label.height")}</label>
                                </div>
                                <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                    <input
                                        type="text"
                                        className="inputbox"
                                        id="edit-height"
                                        aria-labelledby="edit-height"
                                        name="height"
                                        defaultValue={driverLicense.height}
                                        maxLength={30}
                                        onChange={onChangeHandler}
                                    />
                                </div>
                            </div>

                            <div className="form-row inline row">
                                <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                    <label htmlFor="label-dob-month">{tLang("identityVault.secureStorage.lostWallterWidget.drivingLicensePopup.label.dob")}</label>
                                </div>
                                <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                    <div className="row ">
                                        {i18nService.get("Country") == "US" ? (
                                            <>
                                                {dateFields[1]} {dateFields[0]} {dateFields[2]}{" "}
                                            </>
                                        ) : i18nService.get("Country") == "CA" || i18nService.get("Country") == "TW" ? (
                                            <>
                                                {dateFields[2]} {dateFields[1]} {dateFields[0]}{" "}
                                            </>
                                        ) : (
                                            <>
                                                {dateFields[0]} {dateFields[1]} {dateFields[2]}
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className={errors["driverLicenseNumber"] ? "form-row row status-error" : "form-row row"}>
                                <div className="form-row inline row">
                                    <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                        <label htmlFor="edit-license-number">
                                            {tLang("identityVault.secureStorage.lostWallterWidget.drivingLicensePopup.label.licenseNumber")}{" "}
                                            <span className="required" title="Mandatory">
                                                *
                                            </span>
                                        </label>
                                    </div>
                                    <div role="alert" className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                        <input
                                            aria-required="true"
                                            type="text"
                                            className="inputbox"
                                            id="edit-license-number"
                                            aria-labelledby="edit-license-number"
                                            name="driverLicenseNumber"
                                            defaultValue={driverLicense.driverLicenseNumber}
                                            onChange={onChangeHandler}
                                            ref={register({
                                                required: true,
                                                pattern: PATTERNS.LICENCENUMBER.pattern,
                                                minLength: 4,
                                            })}
                                            maxLength={30}
                                        />

                                        {errors.driverLicenseNumber && errors.driverLicenseNumber.type === "pattern" && (
                                            <span className="form-error">
                                                {tLang(
                                                    "identityVault.secureStorage.lostWallterWidget.drivingLicensePopup.validationMessage.licenseNumber.pattern2"
                                                )}
                                            </span>
                                        )}

                                        {errors.driverLicenseNumber && errors.driverLicenseNumber.type === "minLength" && (
                                            <span className="form-error">
                                                {tLang("identityVault.secureStorage.lostWallterWidget.drivingLicensePopup.validationMessage.licenseNumber.pattern")}
                                            </span>
                                        )}

                                        {errors.driverLicenseNumber && errors.driverLicenseNumber.type === "required" && (
                                            <span className="form-error">
                                                {tLang(
                                                    "identityVault.secureStorage.lostWallterWidget.drivingLicensePopup.validationMessage.licenseNumber.required"
                                                )}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className={errors["address1"] ? "form-row row status-error" : "form-row row"}>
                                <div className="form-row inline row">
                                    <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                        <label htmlFor="edit-address">
                                            {tLang("identityVault.secureStorage.lostWallterWidget.drivingLicensePopup.label.address")}
                                        </label>
                                    </div>
                                    <div role="alert" className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                        <input
                                            aria-required="true"
                                            type="text"
                                            className="inputbox"
                                            id="edit-address"
                                            aria-labelledby="edit-address"
                                            name="address1"
                                            defaultValue={driverLicense.address1}
                                            onChange={onChangeHandler}
                                            ref={register({
                                                pattern: /^[a-zA-Z0-9-#,/.\s]+$/,
                                            })}
                                            maxLength={100}
                                        />
                                        {errors.address1 && errors.address1.type === "pattern" && (
                                            <span className="form-error">
                                                {tLang("identityVault.secureStorage.lostWallterWidget.drivingLicensePopup.validationMessage.address.pattern")}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className={errors["address2"] ? "form-row row status-error" : "form-row row"}>
                                <div className="form-row inline row">
                                    <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                        <label htmlFor="edit-address-2">
                                            {tLang("identityVault.secureStorage.lostWallterWidget.drivingLicensePopup.label.address2")}
                                        </label>
                                    </div>
                                    <div role="alert" className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                        <input
                                            aria-required="true"
                                            type="text"
                                            className="inputbox"
                                            id="edit-address-2"
                                            aria-labelledby="edit-address-2"
                                            name="address2"
                                            defaultValue={driverLicense.address2}
                                            onChange={onChangeHandler}
                                            ref={register({
                                                pattern: /^[a-zA-Z0-9-#/.\s]+$/,
                                            })}
                                            maxLength={100}
                                        />
                                        {errors.address2 && errors.address2.type === "pattern" && (
                                            <span className="form-error">
                                                {tLang("identityVault.secureStorage.lostWallterWidget.drivingLicensePopup.validationMessage.address2.pattern")}
                                            </span>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className="form-row inline row">
                                <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                    <label htmlFor="edit-license-state">
                                        {tLang("identityVault.secureStorage.lostWallterWidget.drivingLicensePopup.label.licenseState", {
                                            stateLabel: i18nService.get("State.Label"),
                                        })}
                                    </label>
                                </div>
                                <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                    <input
                                        type="text"
                                        className="inputbox"
                                        id="edit-license-state"
                                        aria-labelledby="edit-license-state"
                                        name="driverLicenseState"
                                        maxLength={30}
                                        defaultValue={driverLicense.driverLicenseState}
                                        onChange={onChangeHandler}
                                    />
                                </div>
                            </div>

                            <div className="form-row inline row">
                                <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                    <label htmlFor="edit-country">{tLang("identityVault.secureStorage.lostWallterWidget.drivingLicensePopup.label.country")}</label>
                                </div>
                                <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                    <select className="inputbox" id="edit-country" name="country" defaultValue={driverLicense.country} onChange={onChangeHandler}>
                                        {countryList.map((val: any) => (
                                            <option key={val.code} value={val.code}>
                                                {val.name}
                                            </option>
                                        ))}
                                    </select>
                                </div>
                            </div>

                            <div className="form-row inline row">
                                <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                    <label htmlFor="label-issue-month">{tLang("identityVault.secureStorage.lostWallterWidget.drivingLicensePopup.label.issueDate")}</label>
                                </div>
                                <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                    <div className="row ">
                                        {i18nService.get("Country") == "US" ? (
                                            <>
                                                {issueDateFields[1]} {issueDateFields[0]} {issueDateFields[2]}{" "}
                                            </>
                                        ) : i18nService.get("Country") == "CA" || i18nService.get("Country") == "TW" ? (
                                            <>
                                                {issueDateFields[2]} {issueDateFields[1]} {issueDateFields[0]}{" "}
                                            </>
                                        ) : (
                                            <>
                                                {issueDateFields[0]} {issueDateFields[1]} {issueDateFields[2]}
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className="form-row inline row">
                                <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                    <label htmlFor="label-expiration-month">{tLang("identityVault.secureStorage.lostWallterWidget.drivingLicensePopup.label.expiryDate")}</label>
                                </div>
                                <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                    <div className="row ">
                                        {i18nService.get("Country") == "US" ? (
                                            <>
                                                {expiryDateFields[1]} {expiryDateFields[0]} {expiryDateFields[2]}{" "}
                                            </>
                                        ) : i18nService.get("Country") == "CA" || i18nService.get("Country") == "TW" ? (
                                            <>
                                                {expiryDateFields[2]} {expiryDateFields[1]} {expiryDateFields[0]}{" "}
                                            </>
                                        ) : (
                                            <>
                                                {expiryDateFields[0]} {expiryDateFields[1]} {expiryDateFields[2]}
                                            </>
                                        )}
                                    </div>
                                </div>
                            </div>

                            <div className="form-row inline row">
                                <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                    <label htmlFor="edit-conditions">
                                        {tLang("identityVault.secureStorage.lostWallterWidget.drivingLicensePopup.label.condition")}
                                    </label>
                                </div>
                                <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                    <input
                                        type="text"
                                        className="inputbox"
                                        id="edit-conditions"
                                        aria-labelledby="edit-conditions"
                                        name="conditions"
                                        maxLength={30}
                                        defaultValue={driverLicense.conditions}
                                        onChange={onChangeHandler}
                                    />
                                </div>
                            </div>

                            <div className="form-row inline row">
                                <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                    <label htmlFor="edit-class">{tLang("identityVault.secureStorage.lostWallterWidget.drivingLicensePopup.label.class")}</label>
                                </div>
                                <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                    <input
                                        type="text"
                                        className="inputbox"
                                        id="edit-class"
                                        aria-labelledby="edit-class"
                                        name="class"
                                        maxLength={30}
                                        defaultValue={driverLicense.class}
                                        onChange={onChangeHandler}
                                    />
                                </div>
                            </div>

                            <div className="form-row inline row">
                                <div className="form-label col-xs-12 col-sm-4 col-no-gutter">
                                    <label htmlFor="edit-notes">{tLang("identityVault.secureStorage.lostWallterWidget.drivingLicensePopup.label.notes")}</label>
                                </div>
                                <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                    <textarea
                                        className="inputbox"
                                        id="edit-notes"
                                        aria-labelledby="edit-notes"
                                        name="notes"
                                        maxLength={500}
                                        style={{ resize: "none" }}
                                        placeholder=""
                                        rows={6}
                                        defaultValue={driverLicense.notes}
                                        onChange={onChangeHandler}
                                    ></textarea>
                                </div>
                            </div>

                            {hasError && (
                                <div className="form-row inline row">
                                    <div className="form-label col-xs-12 col-sm-4 col-no-gutter"></div>
                                    <div className="form-input col-xs-12 col-sm-8 col-no-gutter">
                                        <p className="form-error">{errorMsg}</p>
                                    </div>
                                </div>
                            )}
                        </div>

                        <div className="dialog-footer">
                            <div className="row between-xs">
                                <div className="col-xs col-no-gutter flex-grow-null">
                                    <button type="button" className="btn-default btn-link btn-no-padding btn-no-border" onClick={() => closeDialog()}>
                                        <span className="btn-text">
                                            {tLang("identityVault.secureStorage.lostWallterWidget.drivingLicensePopup.label.cancelButtonText")}
                                        </span>
                                    </button>
                                </div>
                                <div className="col-xs col-no-gutter flex-grow-null">
                                    <button type="submit" className="btn-default btn-primary" disabled={isSubmitting}>
                                        <span className="btn-text">
                                            {tLang("identityVault.secureStorage.lostWallterWidget.drivingLicensePopup.label.saveButtonText")}
                                        </span>
                                    </button>
                                </div>
                            </div>
                        </div>
                    </form>
                </>
            ) : (
                <div className="box loading"></div>
            )}
        </React.Fragment>
    );
};

export default DriverLicenseDialog;
